import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "p-fluid grid justify-content-center align-items-center flex align-content-center mr-0",
  style: {"min-height":"800px"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "field"
}
const _hoisted_4 = { class: "field p-3" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Username*", -1)
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = {
  key: 0,
  class: "field p-3"
}
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "oldPassword" }, "Old Password*", -1)
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = { class: "field p-3" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password*", -1)
const _hoisted_15 = {
  key: 0,
  class: "p-error"
}
const _hoisted_16 = {
  key: 1,
  class: "field p-3"
}
const _hoisted_17 = { class: "p-float-label" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "passwordMatch" }, "Confirm Password*", -1)
const _hoisted_19 = {
  key: 0,
  class: "p-error"
}
const _hoisted_20 = { class: "p-3" }
const _hoisted_21 = { class: "grey col-12 text-center" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_23 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Panel, { class: "col-12 md:col-6 lg:col-4 p-panel-content" }, {
        header: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.styles.logo,
            style: {"height":"45px"}
          }, null, 8, _hoisted_2)
        ]),
        default: _withCtx(() => [
          (_ctx.error != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Message, {
                  severity: "error",
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.error = ''))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.error), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (
          _ctx.handleLogin(!_ctx.v$.$invalid, !_ctx.v$.Email.$invalid, !_ctx.v$.Password.$invalid)
        ), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_InputText, {
                  modelValue: _ctx.v$.Email.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.Email.$model) = $event)),
                  id: "username",
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.Email.$invalid && _ctx.submitted })
                }, null, 8, ["modelValue", "class"]),
                _hoisted_6
              ]),
              (_ctx.v$.Email.$invalid && _ctx.submitted)
                ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.v$.Email.required.$message.replace("Value", "Username")), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.buttonText === _ctx.ButtonTextOptions.UpdatePassword)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_Password, {
                      modelValue: _ctx.v$.OldPassword.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.OldPassword.$model) = $event)),
                      id: "oldPassword",
                      toggleMask: "",
                      feedback: false,
                      class: _normalizeClass({ 'p-invalid': _ctx.v$.OldPassword.$invalid && _ctx.submitted })
                    }, null, 8, ["modelValue", "class"]),
                    _hoisted_10
                  ]),
                  (_ctx.v$.OldPassword.$invalid && _ctx.submitted)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.v$.OldPassword.required.$message.replace("Value", "oldPassword")), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_Password, {
                  modelValue: _ctx.v$.Password.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.Password.$model) = $event)),
                  id: "password",
                  toggleMask: "",
                  feedback: false,
                  class: _normalizeClass({ 'p-invalid': _ctx.v$.Password.$invalid && _ctx.submitted })
                }, null, 8, ["modelValue", "class"]),
                _hoisted_14
              ]),
              (_ctx.v$.Password.$invalid && _ctx.submitted)
                ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.v$.Password.required.$message.replace("Value", "Password")), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.buttonText !== _ctx.ButtonTextOptions.Login)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, [
                    _createVNode(_component_Password, {
                      modelValue: _ctx.v$.PasswordMatch.$model,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.PasswordMatch.$model) = $event)),
                      id: "passwordMatch",
                      toggleMask: "",
                      feedback: false,
                      class: _normalizeClass({ 'p-invalid': _ctx.v$.PasswordMatch.$invalid })
                    }, null, 8, ["modelValue", "class"]),
                    _hoisted_18
                  ]),
                  (_ctx.v$.PasswordMatch.$invalid && _ctx.submitted)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_19, "Passwords do not match"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_Button, {
                loading: _ctx.loading,
                type: "submit",
                label: this.buttonText
              }, null, 8, ["loading", "label"])
            ])
          ], 32)
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_21, [
        _createElementVNode("a", {
          class: _normalizeClass([_ctx.loginActive, "login"]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (this.buttonText = _ctx.ButtonTextOptions.Login))
        }, "Login", 2),
        _hoisted_22,
        _createElementVNode("a", {
          class: _normalizeClass([_ctx.registerActive, "login"]),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (this.buttonText = _ctx.ButtonTextOptions.Register))
        }, "Register", 2)
      ]),
      _createVNode(_component_Footer, { class: "footer" })
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showPasswordValidationError,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showPasswordValidationError) = $event)),
      header: "Password Validation Error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordError.split('\n'), (line) => {
            return (_openBlock(), _createElementBlock("span", {
              key: line,
              class: "block ml-1",
              style: {"min-height":"20px"}
            }, _toDisplayString(line), 1))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}